import styled from 'styled-components'

import { Button } from 'shared/ui/Button'

export const StyledButtonHistory = styled(Button)`
  font-weight: ${(props) => props.theme.fonts.weight.normal};
  padding: 4px 8px;
`
